import React, { Component } from "react";
import { connect } from "react-redux";
import { Link as RouterLink } from "react-router-dom";
import { LOGIN } from "../_utils/routes";
import TldrBase from "../TldrLogin/TldrBase";
import { FaArrowLeft } from "react-icons/fa";
import { withTranslation } from "react-i18next";
import { Flex, Link } from "@chakra-ui/react";

class ResetPasswordEmailSentNotification extends Component {
  render() {
    const { t } = this.props;
    const urlSearchParams = new URLSearchParams(this.props.location.search);
    const searchKeyEmail = decodeURIComponent(urlSearchParams.get("email"));

    return (
      <TldrBase
        subheading={
          <>
            {t("reset_password_email.subheading_1")}{" "}
            <span>{[searchKeyEmail]}</span>{" "}
            {t("reset_password_email.subheading_2")}
          </>
        }
        heading={t("reset_password_email.heading")}
      >
        <Flex mt={5} justify={"center"}>
          <Link
            as={RouterLink}
            to={LOGIN}
            display="flex"
            alignItems={"center"}
            gap="1"
          >
            <FaArrowLeft />
            {t("reset_password_email.back")}
          </Link>
        </Flex>
      </TldrBase>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors,
});

export default connect(mapStateToProps)(
  withTranslation(["auth"])(ResetPasswordEmailSentNotification)
);
